<template>
  <main-layout>
    <baseModal
      id="initialQuestions"
      :show="true"
    >
      <slot name="form" />
      <template slot="footer">
        <base-button
          :disabled="canContinue"
          type="button"
          @click="saveAndNext()"
        >
          Continuar
        </base-button>
      </template>
    </baseModal>
  </main-layout>
</template>

<script>
export default {
    name: 'InitialQuestion',
    props: {
        saveData: {
            type: Function,
            required: true,
        },
        nextQuestion: {
            type: Function,
            required: true,
        },
        disabledCriteria: {
            type: Function,
            required: true,
        },
    },
    computed: {
        canContinue() {
            return this.disabledCriteria();
        },
    },
    methods: {
        saveAndNext() {
            this.saveData().then(() => this.nextQuestion());
        },
    },
};
</script>
